import React from 'react'
import {Switch, Route} from 'react-router-dom'
import MainLayout from '../layouts/Main'

import LoginRoute from './Login'
import ResetPassword from './ResetPassword'
import SignupRoute from './Signup'
import ProjectsRoute from './Projects'
import AccountRoute from './Account'
import Transparencia from './Transparencia'
import NotFoundRoute from './NotFound'
import Home from './Index2'


import Presupuesto from './PresupuestoParticipativo/Principal'
import General from './PresupuestoParticipativo/General'
import Security from './PresupuestoParticipativo/Security'
import Notifications from './PresupuestoParticipativo/Notifications'
import Billing from './PresupuestoParticipativo/Billing'

import Obras from "./Obras"



export const ObrasRoute = {
    path:'/Obras',
    component: Obras
}

export const presupuestoPATH = {
    path: '/presupuesto-participativo',
    component: Presupuesto
}

export const primeraPATH = {
    path: '/presupuesto-participativo-primera',
    component: General
}

export const segundaPATH = {
    path: '/presupuesto-participativo-segunda',
    component: Security
}

export const terceraPATH = {
    path: '/presupuesto-participativo-tercera',
    component: Notifications
}

export const cuartaPATH = {
    path: '/presupuesto-participativo-cuarta',
    component: Billing
}


export default function createRoutes(store) {
    return (
        <MainLayout>
            <Switch>


                <Route exact path={Home.path} component={() => <Home.component/>}/>
                {/* Build Route components from routeSettings */
                    [
                        AccountRoute,
                        ProjectsRoute,
                        SignupRoute,
                        LoginRoute,
                        Transparencia,
                        ResetPassword,
                        presupuestoPATH,
                        primeraPATH,
                        segundaPATH,
                        terceraPATH,
                        cuartaPATH,
                        // Ruta de obras
                        ObrasRoute
                        /* Add More Routes Here */
                    ].map((settings, index) => (
                        <Route key={`Route-${index}`} {...settings} />
                    ))}
                <Route component={NotFoundRoute.component}/>
            </Switch>
        </MainLayout>
    )
}
